import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useContext } from 'react';
import TextField from '../TextField/TextField';
import { SiteContext } from '../../utils/common';
import useStyles from './CollectionInstructions.styles';
import { collectionInstructionPlaceholder, collectionInstructionsTitle, collectionText } from '../../utils/constants';
import { FormikContext } from 'formik';
const maxLength = 90;
const CollectionInstructions = () => {
    const { classes } = useStyles();
    const { isFlyingFlowers } = useContext(SiteContext);
    const formikContext = useContext(FormikContext);
    const { values, setFieldValue } = formikContext !== null && formikContext !== void 0 ? formikContext : {};
    const { deliveryInstructionNote = '' } = values !== null && values !== void 0 ? values : {};
    const handleChange = (e) => {
        setFieldValue === null || setFieldValue === void 0 ? void 0 : setFieldValue('deliveryInstructionNote', e.target.value, false);
    };
    return (_jsx(_Fragment, { children: !isFlyingFlowers && (_jsxs("div", { children: [_jsx("div", { className: classes.title, children: collectionInstructionsTitle }), _jsx("div", { className: classes.text, children: collectionText }), _jsxs("div", { className: classes.collectionInput, children: [_jsxs("span", { className: classes.collectionCharacterCount, children: [deliveryInstructionNote.length, "/", maxLength] }), _jsx(TextField, { className: classes.collectionTextarea, name: "collectionInstructionNote", label: "", placeholder: collectionInstructionPlaceholder, multiline: true, rows: 7, hideRequiredOptional: true, fullWidth: true, trimOnBlur: true, value: deliveryInstructionNote, onChange: handleChange, inputProps: {
                                maxLength,
                            } })] })] })) }));
};
export default CollectionInstructions;
